import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: () => import('../views/LoginPage.vue') },
  {
    path: '/layout',
    component: () => import('../views/LayoutPage.vue'),
    children: [
      { path: '/', redirect: '/contract/list' }, // 默认跳合同列表
      { path: '/dashboard', component: () => import('../views/DashBoard.vue') },
      { path: '/user', name: 'User', component: () => import('../views/user/UserPermission.vue') },
      { path: '/device/list', component: () => import('../views/device/DeviceIndex.vue') },
      { path: '/product/list', component: () => import('../views/product/ProductIndex.vue') },
      { path: '/template/list', component: () => import('../views/template/TemplateIndex.vue') },

      // 合同模块（恢复完整嵌套路由）
      {
        path: '/contract',
        children: [
          // 合同列表页（项目管理）
          { path: 'list', component: () => import('../views/contract/ContractIndex.vue') },
          { path: 'addedit', component: () => import('../views/contract/detail/ContractAddEdit.vue') },

          // 合同详情父布局（承载子路由）
          {
            path: 'detail/:contractNo', // 仅定义param参数（contractNo），query参数自动携带
            // component: () => import('../views/contract/ContractDetailLayout.vue'),
            children: [
              { path: '', redirect: 'preview' }, // 默认跳预览页
              { path: 'preview', name: 'ContractPreview', component: () => import('../views/contract/detail/ContractPreview.vue') },
              { path: 'basic', name: 'ContractBasic', component: () => import('../views/contract/detail/ContractBasic.vue') },
              { path: 'contact', name: 'ContractContact', component: () => import('../views/contract/detail/ContractContact.vue') },
              { path: 'device', name: 'ContractDevice', component: () => import('../views/contract/detail/ContractDevice.vue') }
            ]
          }
        ]
      },

      // 设备资料详情（恢复完整嵌套路由）
      {
        path: '/device/detail/:id', // 仅定义param参数（设备ID），contractNo是query参数无需在path中定义
        children: [
          { path: '', redirect: 'preview' } // 默认跳预览页
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫：登录校验（保持不变）
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    next()
  } else {
    token ? next() : next('/login')
  }
})

export default router
